<mat-card appearance="outlined">
  <mat-card-title [innerText]="'MAIN_APP_ADRESSES.ansprechpartnerErfassen' | translate"></mat-card-title>
  <mat-card-content [formGroup]="formGroupPartner">
    <span class="row">
      <mat-checkbox formControlName="fldPartnerAlsHauptkontakt" style="flex: 1;">
        {{ "MAIN_APP_ADRESSES.alsHauptansprechpartnerDefinieren" | translate }}
      </mat-checkbox>
      <!-- <mat-checkbox class="cbInaktiv-margin" formControlName="fldPartnerPersKontakt" style="margin: 0;width:'calc(50%)'"> -->
    </span>
    <span class="row">
      <mat-checkbox formControlName="fldPartnerPersKontakt" style="flex: 1;">
        {{ "MAIN_APP_ADRESSES.persönlicherKontakt" | translate }}
      </mat-checkbox>
    </span>
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.name" | translate }} </mat-label>
        <input matInput formControlName="fldPartnerName" (keyup)="onNameChange($event)" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.vorname" | translate }} </mat-label>
        <input matInput formControlName="fldPartnerVorname" (keyup)="onVornameChange($event)" />
      </mat-form-field>
    </span>
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.anrede" | translate }}</mat-label>
        <mat-select required formControlName="fldPartnerAnrede">
          <mat-option *ngFor="let anrede of anreden" [value]="anrede.anrede">
            {{anrede.anrede}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.briefanrede" | translate }}</mat-label>
        <mat-select required formControlName="fldPartnerBriefanrede">
          <mat-option *ngFor="let briefanrede of briefAnredenAbgefuellt" [value]="briefanrede.briefanrede">
            {{ briefanrede.briefanrede }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.zuHanden" | translate }}</mat-label>
        <mat-select required formControlName="fldPartnerZuHanden">
          <mat-option *ngFor="let zuha of zuHandenAbgefuellt" [value]="zuha">
            {{ zuha }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.info" | translate }} </mat-label>
        <input matInput formControlName="fldPartnerInfo" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.mobile" | translate }} </mat-label>
        <input matInput formControlName="fldPartnerMobile" />
      </mat-form-field>
    </span>
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.telefon" | translate }} </mat-label>
        <input matInput formControlName="fldPartnerTelefon" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.email" | translate }} </mat-label>
        <input matInput formControlName="fldPartnerEmail" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.homepage" | translate }} </mat-label>
        <input matInput formControlName="fldPartnerHomepage" />
      </mat-form-field>
    </span>
  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="save()" [disabled]="!formGroupPartner.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
